import * as React from "react";

function Clock(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 20 20" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.929 2.929A9.972 9.972 0 0110 0a9.972 9.972 0 017.071 2.929A9.972 9.972 0 0120 10a9.972 9.972 0 01-2.929 7.071A9.972 9.972 0 0110 20a9.972 9.972 0 01-7.071-2.929A9.972 9.972 0 010 10a9.972 9.972 0 012.929-7.071zM10 2c-2.21 0-4.208.894-5.657 2.343A7.972 7.972 0 002 10c0 2.21.894 4.208 2.343 5.657A7.972 7.972 0 0010 18c2.21 0 4.208-.894 5.657-2.343A7.972 7.972 0 0018 10c0-2.21-.894-4.208-2.343-5.657A7.972 7.972 0 0010 2z"
        fill={props.color||"#FF9500"}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 5a1 1 0 011 1v4a1 1 0 11-2 0V6a1 1 0 011-1z"
        fill={props.color||"#FF9500"}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.293 9.293a1 1 0 011.414 0l2 2a1 1 0 01-1.414 1.414l-2-2a1 1 0 010-1.414z"
        fill={props.color||"#FF9500"}
      />
    </svg>
  );
}

export default Clock;
